<div class="modal-inner resettle-diff">
    <h1>Verschillen na opnieuw verrekenen</h1>

    @if (differences.length === 0) {
        <p class="no-differences">Geen verschillen gevonden.</p>
    } @else {
        <div class="diff-table-wrapper">
            <table class="diff-table">
                <thead>
                    <tr>
                        <th class="col-date">Datum</th>
                        <th>Uursoort</th>
                        <th class="col-value">Huidig</th>
                        <th class="col-value">Nieuw</th>
                        <th class="col-value">Verschil</th>
                        <th class="col-choice">Aanhouden</th>
                    </tr>
                </thead>
                <tbody>
                    @for (difference of differences; track difference) {
                        <tr [class.not-correctable]="!difference.correctable">
                            <td class="col-date">{{ difference.date | date: 'EEE d MMM yyyy' }}</td>
                            <td>
                                <strong class="hourtype-code">{{ difference.hourtypeCode }}</strong>
                                {{ difference.hourtypeDescription }}
                            </td>
                            <td class="col-value">
                                @if (isDistance(difference.hourtypeCode)) {
                                    {{ difference.current }} km
                                } @else {
                                    {{ difference.current | minutes }}
                                }
                            </td>
                            <td class="col-value">
                                @if (isDistance(difference.hourtypeCode)) {
                                    {{ difference.recalculated }} km
                                } @else {
                                    {{ difference.recalculated | minutes }}
                                }
                            </td>
                            <td class="col-value delta" [class.negative]="difference.delta < 0">
                                {{ difference.delta > 0 ? '+' : '' }}
                                @if (isDistance(difference.hourtypeCode)) {
                                    {{ difference.delta }} km
                                } @else {
                                    {{ difference.delta | minutes }}
                                }
                            </td>
                            <td class="col-choice">
                                @if (difference.correctable) {
                                    <mat-radio-group [(ngModel)]="difference.useRecalculated" [disabled]="saving">
                                        <mat-radio-button [value]="true">Nieuw</mat-radio-button>
                                        <mat-radio-button [value]="false">Huidig</mat-radio-button>
                                    </mat-radio-group>
                                } @else {
                                    <span class="too-much">Te veel toegekend, niet te corrigeren</span>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <p class="explanation">
            Er worden alleen aanvullende regels aangemaakt voor een positief verschil. Bestaande regels blijven staan en
            worden niet gewijzigd of uit Afas verwijderd.
        </p>
    }

    @if (saving) {
        <div class="saving">
            <mat-progress-bar [mode]="progress.total ? 'determinate' : 'indeterminate'" [value]="progressPercentage">
            </mat-progress-bar>

            <p class="saving-label">Correcties opslaan&hellip; {{ progress.done }} van {{ progress.total }}</p>
        </div>
    }

    <div class="buttons">
        <button [disabled]="saving" class="planning-button cancel" mat-raised-button mat-dialog-close="">
            Annuleren
        </button>
        <button
            [disabled]="accepted.length === 0 || saving"
            (click)="confirm()"
            class="planning-button confirm"
            color="primary"
            mat-raised-button>
            @if (saving) {
                Bezig met opslaan&hellip;
            } @else {
                {{ accepted.length }} correctie{{ accepted.length === 1 ? '' : 's' }} doorvoeren
            }
        </button>
    </div>
</div>
